import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_LARGE } from '~/constants';

import { zodContractItemSchema } from '../validations';

/**
 * Validation schemas for contract items list API calls.
 */

// Query parameter validations
export const zodContractItemsQueryParamsSchema = z.object({
  limit: z.number().int().min(1).max(500).default(PAGINATION_PAGE_SIZE_LARGE),
  offset: z.number().int().min(0).default(0),
  searchString: z.string().trim().nullish(),
});

// Response schema
export const zodContractItemsResponseSchema = z.object({
  data: z.array(zodContractItemSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
});
